<template>
  <div>
    <hr class="my-5" />
    <div class="print-only">
      <StatementHeader :header-img="headerImg" />
    </div>
    <div class="pt-5">
      <div class="container-fluid sans">
        <div class="row">
          <div class="col-12">
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
              <div>
                <p class="sans gold" style="margin-bottom: 5px; font-size: 50px;">ACTIVITY STATEMENT</p>
              </div>
              <div style="width: 10%;">
                <div style="text-align: center;">
                </div>
              </div>
              <p class="sans dark-blue pb-0" style="text-align: right; margin-bottom: 5px; font-size: 25px;">
                {{ date ? moment(date).format('DD/MM/YYYY') : '' }}
              </p>
            </div>
            <div v-if="expiresInOneMonth(item.purchase)"
              style="width: 100%; display: flex; justify-content: end; padding-bottom: 1rem;">
              <div>
                <p class="sans red-badge">
                  APPROACHING EXPIRY
                </p>
              </div>
            </div>
            <div class="pt-3" style="width: 100%; display: flex; justify-content: space-between;">
              <div style="display: flex; flex-direction: column;">
                <div style="margin-bottom: 20px">
                  <p class="text-section dark-blue">{{ business.agency.name }}</p>
                  <p class="text-section main-color">{{ business.agency.address }}</p>
                </div>
                <div>
                  <p class="text-section shippori dark-blue">{{ business.name }}</p>
                  <p class="text-section main-color">{{ business.address }}</p>
                </div>
              </div>

              <div>
                <table class="dark-blue" style="font-size: 20px;  text-align: left; margin-right: 25px;">
                  <tbody>
                    <tr style="margin-bottom: 20px">
                      <td class="extra main-color" style="text-align: right;">BSA #</td>
                      <td class="extra main-color" style="padding-left: 10px">{{ item.purchase.id }}</td>
                    </tr>
                    <tr style="margin-bottom: 20px">
                      <td style="text-align: right;">BSA Expiry</td>
                      <td class="main-color" style="padding-left: 10px">{{ item.purchase.invoice_due_date ?
                        moment(item.purchase.invoice_due_date).format('DD/MM/YYYY') : '' }}</td>
                    </tr>
                    <tr style="margin-bottom: 20px">
                      <td style="text-align: right;">AGENCY REF</td>
                      <td class="main-color" style="padding-left: 10px">{{ item.purchase.reference_code }}</td>
                    </tr>
                    <tr style="margin-bottom: 20px">
                      <td style="text-align: right; text-transform: uppercase;">{{ item.purchase.contract_type || '' }}
                        RATE</td>
                      <td class="main-color" style="padding-left: 10px">{{ item.purchase.channel.rate ?
                        _.round(item.purchase.channel.rate / 365, 4) + '% / day' : '' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pb-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <table class="principal bordered mt-3" style=" width: 100%;">
              <thead style="text-align: center;">
                <tr>
                  <th class="bg-gold white">DATE</th>
                  <th class="bg-gold white">INV #</th>
                  <th class="bg-gold white">No. HD</th>
                  <th class="bg-gold white">PURCHASE / (SALE)</th>
                  <th class="bg-gold white">MGMT FEE (PAID)</th>
                  <th class="bg-gold white">DEPOSIT</th>
                  <th class="bg-gold white">BALANCE</th>
                </tr>
              </thead>
              <tbody style="text-align: center;">
                <tr v-for="lineItem in item.lineItems">
                  <td>{{ moment(lineItem.date).format('DD.MM.YYYY') }}</td>
                  <td v-if="lineItem.type == 'purchase'"></td>
                  <td v-if="lineItem.type == 'purchase'">{{ lineItem.livestock_head_purchased }}</td>
                  <td v-if="lineItem.type == 'purchase'">{{ formatValueCurrency(lineItem.livestock_purchase_inc_gst) }}
                  </td>
                  <td v-if="lineItem.type == 'purchase'">{{ item.purchase.channel &&
                    item.purchase.channel.term_category_id == 1 ?
                    formatValueCurrency(lineItem.management_fee_balance_inc_gst) : '' }}</td>

                  <td v-if="lineItem.type == 'sale'">{{ lineItem.sale ? lineItem.sale.xero_invoice_no : '' }}</td>
                  <td v-if="lineItem.type == 'sale'">({{ Math.abs(lineItem.livestock_head_sold) }})</td>
                  <td v-if="lineItem.type == 'sale'">({{ formatValueCurrency(Math.abs(lineItem.livestock_sale_inc_gst))
                  }})</td>
                  <td v-if="lineItem.type == 'sale'">({{
                    formatValueCurrency(Math.abs(lineItem.management_fee_paid_inc_gst)) }})</td>

                  <td v-if="lineItem.type == 'management fee'"></td>
                  <td v-if="lineItem.type == 'management fee'"></td>
                  <td v-if="lineItem.type == 'management fee'"></td>
                  <td v-if="lineItem.type == 'management fee'">{{
                    formatValueCurrency(lineItem.management_fee_balance_inc_gst) }}</td>

                  <td v-if="lineItem.type == 'adjustment'"></td>
                  <td v-if="lineItem.type == 'adjustment'"></td>
                  <td v-if="lineItem.type == 'adjustment'"></td>
                  <td v-if="lineItem.type == 'adjustment'">{{ formatValueCurrency(lineItem.management_fee_balance_inc_gst)
                  }}</td>

                  <td v-if="lineItem.livestock_deposit > 0">{{ lineItem.livestock_deposit && lineItem.livestock_deposit !=
                    0 ? "(" + formatValueCurrency(Math.abs(lineItem.livestock_deposit)) + ")" : '' }}</td>
                  <td v-else-if="lineItem.livestock_deposit < 0">{{ lineItem.livestock_deposit ?
                    formatValueCurrency(Math.abs(lineItem.livestock_deposit)) : '' }}</td>
                  <td v-else></td>

                  <td v-if="lineItem.contract_balance_inc_gst < 0">{{ formatValueCurrency(0) }}</td>
                  <td v-else>{{ formatValueCurrency(lineItem.contract_balance_inc_gst) }}</td>
                </tr>

                <tr v-if="item.finalItem" class="dark-blue"
                  style="border-top: 1px solid #d3cfbd; border-bottom: 1px solid #d3cfbd;">
                  <td class="bg-light-grey extra">{{ moment(item.finalItem.date).format('DD.MM.YYYY') }}</td>
                  <td class="bg-light-grey extra"></td>
                  <td class="bg-light-grey extra">{{ item.finalItem.livestock_head_on_hand }}</td>
                  <td class="bg-light-grey extra">{{ formatValueCurrency(item.finalItem.livestock_balance_inc_gst) }}</td>
                  <td class="bg-light-grey extra">{{ formatValueCurrency(item.finalItem.management_fee_balance_inc_gst) }}
                  </td>

                  <td v-if="item.finalItem.livestock_deposit_sum" class="bg-light-grey extra">({{
                    formatValueCurrency(item.finalItem.livestock_deposit_sum) }})</td>
                  <td v-else class="bg-light-grey extra"></td>
                  <td v-if="item.finalItem.contract_balance_inc_gst < 0" class="bg-light-grey extra">{{
                    formatValueCurrency(0) }}</td>
                  <td v-else class="bg-light-grey extra">{{ formatValueCurrency(item.finalItem.contract_balance_inc_gst)
                  }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row pt-3 pl-4">
          <p style="font-size: 16px;">* Statement is inclusive of GST</p>
        </div>

        <div class="row pt-3 pl-4">
          <p style=" color: #0a337b; font-size: 16px;">
            For a formalised payout figure please contact Ottley Capital at <a
              href="admin@ottleycapital.com">admin@ottleycapital.com</a>
          </p>
        </div>
      </div>
    </div>
    <div class="print-only" :style="!lastInLoop ? 'page-break-after: always;' : ''">
      <StatementFooter v-if="!lastInLoop" />
    </div>
  </div>
</template>

<script>
import StatementHeader from "./StatementHeader";
import StatementFooter from "./StatementFooter";

export default {
  components: [StatementHeader, StatementFooter],
  props: {
    statementId: {
      type: Number | String,
      required: false
    },
    statement: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: false
    },
    item: {
      type: Object,
      required: true
    },
    business: {
      type: Object,
      required: true
    },
    headerImg: {
      type: String
    },
    lastInLoop: {
      type: Boolean
    }
  },
  data() {
    return {

    }
  },
  methods: {
    expiresInOneMonth(purchase) {
      let openHead = purchase.balance_as_of_date ? purchase.balance_as_of_date.livestock_head_on_hand : 0;
      let expiry = moment(purchase.invoice_due_date);
      let datePlusOneMonth = moment(this.date).clone().add(1, 'M');
      return expiry.isBefore(datePlusOneMonth) && expiry.isBetween(moment(this.date), datePlusOneMonth)
        && (openHead > 0 && purchase.balance_as_of_date.contract_balance_inc_gst > 0.1);
    },
    formatValueCurrency(value) {
      return Number(value).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    },
  }
}
</script>

<style scoped>
html {
  -webkit-print-color-adjust: exact;
}

.sans {
  font-family: 'Roboto', sans-serif !important;
}

.serif {
  font-family: Georgia, 'Times New Roman', Times, serif;
}

.shippori {
  font-family: 'Shippori Mincho' !important;
}

.main-color {
  color: #231f20;
}

.sub-color {
  color: #888380;
}

.white {
  color: #ffffff;
}

.bg-light-grey {
  background-color: #f0f0f0;
}

.bg-sub-color {
  background-color: #888380;
}

.dark-blue {
  color: #25405d;
}

.gold {
  color: #d3cfbd !important;
}

.bg-gold {
  background-color: #d3cfbd
}

th {
  font-weight: 600 !important;
  vertical-align: middle;
}

table.principal {
  border: none;
}

table.principal th {
  padding: 10px;
  border: none;
}

table.principal td {
  padding: 7px 10px 7px 10px;
  border-bottom: 1px solid #f0f0f0 !important;
  border-top: none;
}

.extra {
  font-weight: 600;
}

.text-header {
  font-size: 18px;
  margin-bottom: 5px;
  padding-left: 25px;
}

.text-section {
  font-size: 18px;
  margin-bottom: 5px;
}

.red-badge {
  border-radius: 36px;
  background-color: #f5b0b0;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  padding: 0.5em 3em;
}

.print-only {
  display: none;
}

@media print {
  hr {
    display: none;
  }

  .print-only {
    display: block;
  }
}
</style>
